// @ts-nocheck
/* eslint-disable */
/**
 * @class Pano značka
 * @augments SMap.Marker
 * @signal marker-change
 * @group map-pano
 */
Mapy.Pano.Marker = function(coords, id, options) {
	var cover = document.createElement("div");
	var img = document.createElement("img");
	img.src = "/img/pano/eye.png";

	cover.appendChild(img);

	var vo = document.createElement("img");
	vo.src = "/img/pano/vo.png";
	vo.style.position = "absolute";
	vo.style.left = "-34px";
	vo.style.top = "-52px";
	vo.style.pointerEvents = "none";

	cover.appendChild(vo);

	var o = {
		url: cover,
		anchor: {left:12, top:8}
	}
	for (var p in options) { o[p] = options[p]; }

	this._angle = 0;
	SMap.Pano.Marker.call(this, coords, id, o);
};

Mapy.Pano.Marker.prototype = Object.create(Object.assign({}, SMap.Marker.prototype, SMap.Pano.Marker.prototype));

Mapy.Pano.Marker.prototype.setAngle = function(angle) {
	JAK.CSS3.set(this._dom.container[SMap.LAYER_MARKER], "transform", "rotate(" + angle + "deg)");
	this._angle = angle;
};

Mapy.Pano.Marker.prototype.getYaw = function() {
	return (this._angle / 180 * Math.PI);
};
